<template>
  <span>
  <img src="/clientV2/static/gfx/ExtendedB.svg"
       class="iconBtn transition"
       v-if="options.type === 'extended'"
       @click="options.type = 'extended'"
       v-tippy="{ placement : 'top'}"
       :title="'תצוגה מורחבת'">
 <img src="/clientV2/static/gfx/ExtendedG.svg"
      class="iconBtn transition"
      @click="options.type = 'extended'"
      v-if="options.type === 'narrow'"
      v-tippy="{ placement : 'top'}"
      :title="'תצוגה מורחבת'">

     <img src="/clientV2/static/gfx/NarrowB.svg"
          class="iconBtn transition"
          v-if="options.type === 'narrow'"
          @click="options.type = 'narrow'"
          v-tippy="{ placement : 'top'}"
          :title="'תצוגה מצומצמת'">
     <img src="/clientV2/static/gfx/NarrowG.svg"
          class="iconBtn transition"
          @click="options.type = 'narrow'"
          v-if="options.type === 'extended'"
          v-tippy="{ placement : 'top'}"
          :title="'תצוגה מצומצמת'">
  </span>
</template>

<script>
  export default {
    name: 'FilesElement',
    props: ['options'],
    data () {
      return {
      }
    },
    methods: {
      emitEvent: function (data) {
        this.$emit('emit', data)
      }
    },
    watch: {
      'options.type': function () {
        this.emitEvent({method: 'tableDisplayChanged', data: this.options.type})
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/style.less";

  ul {
    li {
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/toolbar/ExtendElement.vue